// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var Number = React.forwardRef(function Number(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Number" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.8926 16.6364L16.6199 21H13.8915L14.1642 16.6364L10.3471 16.6364L10.0744 21H7.34606L7.61879 16.6364H3V13.9091H7.78924L8.02788 10.0909L3 10.0909V7.36364L8.19833 7.36364L8.47106 3H11.1994L10.9267 7.36364H14.7438L15.0165 3H17.7449L17.4721 7.36364L21 7.36364V10.0909H17.3017L17.063 13.9091H21V16.6364H16.8926ZM10.7562 10.0909L10.5176 13.9091L14.3347 13.9091L14.5733 10.0909H10.7562Z", fill: "currentColor" }))));
});
Number.displayName = 'Number';
export default Number;
//# sourceMappingURL=Number.js.map